<div class="d-flex justify-content-between w-100">
	<h3>{{ data.editable ? 'Dodaj notatke' : 'Podgląd notatki' }}</h3>
	<i (click)="dialogRef.close()" role="button" class="fas fa-times fs-2"></i>
</div>
<div class="form">
	<div class="d-flex">
		<div class="me-4">
			<div class="mb-3">
				<mat-form-field class="w-note" appearance="outline">
					<mat-label class="form-label">Treść zmodyfikowanej notatki</mat-label>
					<textarea [disabled]="!data.editable" [(ngModel)]="noteText" rows="10" matInput></textarea>
				</mat-form-field>
				<div class="d-flex justify-content-end mt-2">
					<button [hidden]="!data.editable" mat-raised-button color="accent" (click)="Input.click()">
						<i class="fa-solid fa-file-circle-plus"></i> Dodaj zdjęcia
					</button>
					<input #Input class="d-none" type="file" multiple (change)="uploadFile($event)" />
				</div>
				<div *ngFor="let image of uploadedMultimedia; let i = index">
					<div class="d-flex justify-content-center my-2">
						<img width="200px" height="100px" [src]="image.url" />
						<div class="align-self-center ms-3">
							<button [disabled]="!data.editable" (click)="deleteImage(i)" mat-raised-button color="warn">
								Usuń zdjęcie
								<i class="fas fa-times"></i>
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div>
			Rodzaj notatek
			<section>
				<ul *ngFor="let item of data.kinds" class="list-inline">
					<li>
						<mat-checkbox
							[disabled]="!data.editable"
							color="primary"
							[(ngModel)]="item.isChecked"
							[checked]="item.isChecked"
						>
							{{ item.name }}
						</mat-checkbox>
					</li>
				</ul>
			</section>
		</div>
	</div>
	<p class="text-secondary text-decoration-underline" *ngIf="!data.editable">
		Notatkę można edytować tylko przez 15 min od jej utworzenia!
	</p>
	<div class="text-end">
		<button [hidden]="!data.editable" mat-raised-button color="primary" (click)="saveNote()">Zapisz</button>
	</div>
</div>
